module.exports = __webpack_public_path__ + "assets/img/classic.17e2821c.jpg";